import React from 'react';
import './LogoLoader.css';

const LogoLoader = ({ size = 64, message = "Loading..." }) => {
  return (
    <div className="logo-loader">
      <div className="logo-loader__icon">
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
          <g className="logo-loader__wings">
            <path d="M23 19.2133L12.0193 3L10.6293 8.14496C10.144 10.8733 10.0589 14.9409 11.6789 17.9296C12.3748 19.2119 13.2442 20.2944 14.2867 20.657C14.2867 20.657 15.3006 21.3878 17.6789 20.7159L23 19.2133Z" fill="#95989C"/>
            <path d="M1 19.2133L11.9812 3L13.3716 8.14496C13.857 10.8733 13.9421 14.9409 12.3221 17.9296C11.6261 19.2119 10.7562 20.2944 9.71425 20.657C9.71425 20.657 8.70031 21.3878 6.3221 20.7159L1 19.2133Z" fill="#1B92A6"/>
          </g>
        </svg>
      </div>
      {message && <p className="logo-loader__message">{message}</p>}
    </div>
  );
};

export default LogoLoader; 